import { MijnRoute } from '../../mijn-navigatie.model';

export const LOAN_APPLY: MijnRoute = {
    path: 'leningen-aanvragen',
    navigationEvent: 'toLenen',
    regex: /^\/leningen-aanvragen$/,
    webcomponent: 'mijn-leningen-aanvragen-webcomponent'
};
